export default __webpack_public_path__ + "images/a6f688cd748947978a50ce97d64d16bb-x-purple.svg";